<ng-container *ngIf="routeStation; else noActiveRouteStation">
    <div class="mt-3">
        <div class="card shadow rounded-0 p-3">
            <avs-bilderkatalog [title]="'Bilder'" [images]="unassignedImages"
                (myClick)="onUnassignedProjectImageClicked($event)"></avs-bilderkatalog>
        </div>
    </div>
    <div class="mt-3">
        <div class="card shadow rounded-0 p-3">
            <div class="d-flex justify-content-between align-items-center mb-2">
                <p class="fw-semibold text-secondary mb-0">Gesetzte Bilder</p>
                <img (click)="onGenerateAnimatedImageClicked()" class="avs-icon-add"
                     src="assets/icons/images.svg" alt="Wechselbild erstellen">
            </div>
            <div class="row avs-project-images-container justify-content-center">
                <ng-container *ngFor="let item of enrichedStationImages; trackBy: trackByStationImage">
                    <div (click)="onProjectImageClicked(item.image)" class="mb-3 avs-project-images">
                        <div class="d-flex justify-content-center">
                            <div class="position-relative">
                                <img [src]="getImagePath(item.image)" alt="Bild">
                                <!-- Animated (top-right) -->
                                <img *ngIf="item.image.isAnimated" src="assets/icons/shuffle.svg" alt="animatedImage"
                                     class="position-absolute bg-white rounded-5 p-1"
                                     style="top: 1px; right: 2px; height: 20px">
                                <!-- Upload-Status (top-left) -->
                                <img *ngIf="item.image.stellcodeStatusOk === true" src="assets/icons/status-ok-bold.svg" alt="status-ok"
                                     class="position-absolute bg-white rounded-5 p-1"
                                     style="top: 1px; left: 2px; height: 26px">
                                <img *ngIf="item.image.stellcodeStatusOk === false" src="assets/icons/status-not-ok-bold.svg" alt="status-not-ok"
                                     class="position-absolute bg-white rounded-5 p-1"
                                     style="top: 1px; left: 2px; height: 26px">
                            </div>
                        </div>
                        <div class="d-flex justify-content-center gap-2 mt-1 border rounded px-1 py-1" style="min-height: 32px;">
                            <ng-container *ngIf="item.refs.length > 0">
                                <span *ngFor="let ref of item.refs; trackBy: trackByRefType"
                                      class="d-inline-flex align-items-center justify-content-center"
                                      style="width: 22px; height: 22px; flex-shrink: 0;"
                                      [title]="getRefTypeLabel(ref.type) + '\n' + ref.labels.join('\n')">
                                    <img [src]="getRefTypeIcon(ref.type)" style="width: 17px; height: 17px;">
                                </span>
                            </ng-container>
                        </div>
                        <div class="small text-center">Stellcode: {{ item.image.stellcode }}</div>
                    </div>
                </ng-container>
            </div>
            <!-- Stellcodes ohne zugewiesenes Bild -->
            <div *ngIf="missingRefStellcodesByType.length > 0" class="mt-2 pt-2 border-top">
                <small class="text-secondary fw-semibold">Bilder nicht zugewiesen:</small>
                <div class="mt-1 d-flex flex-row flex-wrap gap-4">
                    <div *ngFor="let group of missingRefStellcodesByType; trackBy: trackByMissingRefGroup" class="d-flex align-items-center gap-2">
                        <span class="d-inline-flex align-items-center justify-content-center flex-shrink-0"
                              style="width: 20px; height: 20px;"
                              [title]="group.label">
                            <img [src]="getRefTypeIcon(group.type)" style="width: 16px; height: 16px;">
                        </span>
                        <div class="d-flex flex-wrap gap-1">
                            <span *ngFor="let stellcode of group.stellcodes; trackBy: trackByStellcode"
                                  class="badge rounded-pill border border-secondary text-secondary fw-normal">
                                {{ stellcode }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="mt-3">
        <div class="card shadow rounded-0 p-3">
            <h6 class="text-secondary">Upload & Synchronisierung</h6>
            <div class="d-flex flex-wrap align-items-stretch gap-3 mt-2">
                <div class="action-group">
                    <p class="mb-2 text-secondary">Upload</p>
                    <button class="btn btn-secondary rounded-0 w-100 action-button" [disabled]="isUploadJobActive"
                        (click)="onUploadImagesClicked()">Bilder hochladen</button>
                </div>

                <div class="action-group">
                    <p class="mb-2 text-secondary">Kanalbezogene Aktionen</p>
                    <div class="d-flex flex-wrap align-items-start gap-2">
                        <div class="sync-channel-select position-relative" *ngIf="showSyncChannelSelect">
                            <div [ngClass]="isSyncStellcodeOpen ? 'border-danger' : ''"
                                class="border d-flex justify-content-between"
                                [class.opacity-50]="isUploadJobActive"
                                role="button"
                                (click)="!isUploadJobActive && (isSyncStellcodeOpen = !isSyncStellcodeOpen)">
                                <div class="ms-2 p-1 text-nowrap">{{ selectedSyncStellcode.name }}</div>
                                <img *ngIf="!isSyncStellcodeOpen" class="me-2" src="assets/icons/caret-down.svg"
                                    alt="caret-down open select">
                                <img *ngIf="isSyncStellcodeOpen" class="me-2" src="assets/icons/caret-up.svg"
                                    alt="caret-up close select">
                            </div>
                            <avs-dropdown [selectInput]="channelSyncStellcodeSettings" [activeItem]="selectedSyncStellcode"
                                (onItemClicked)="onChannelDropdownSyncStellcodeValueChange($event)" [isHeaderActive]="false"
                                *ngIf="isSyncStellcodeOpen && !isUploadJobActive" class="position-absolute w-100">
                            </avs-dropdown>
                        </div>

                        <button class="btn btn-secondary rounded-0 action-button"
                            [disabled]="areSyncChannelActionsDisabled"
                            (click)="onRefreshStatusClicked()">Status aktualisieren</button>

                    </div>
                </div>
            </div>
            <div *ngIf="isUploadJobActive" class="mt-3 d-flex align-items-center gap-2 text-secondary">
                <span>⏳</span>
                <span>Upload-Job läuft. Bitte warten...</span>
            </div>
        </div>
    </div>
</ng-container>
<ng-template #noActiveRouteStation>
    <p class="mt-3 fw-semibold text-secondary">Keine Station ausgewählt!</p>
</ng-template>
